module.exports = __webpack_public_path__ + "static/media/backspace.c37b7ac3.svg";